import LockedFilePreview from './LockedFilePreview.component';

export default LockedFilePreview;
